import { useSelector } from "react-redux";
import Voucher from "./Voucher";
import Details from "./Details";

const Pricing = () => {
  const cartAggregate = useSelector((state) => state.cart.data.cart);
  return (
    <section className="mb-3">
      <Voucher />
      <Details data={cartAggregate} />
    </section>
  )
}

export default Pricing